import { IAuditModel } from './base';
import { IUser } from './user';

export interface IFlag extends IAuditModel {
  _id: string;
  name: string;
  code: string;
  description?: string;
  isImportant?: boolean;
  isActive: boolean;
}

export enum FlagOrigin {
  MANUAL = 'MANUAL',
  SYSTEM = 'SYSTEM',
}

export enum SystemFlagType {
  WANTED_PERSON = 'WANTED_PERSON',
  JMS_RISK_ASSESSMENT = 'JMS_RISK_ASSESSMENT',
  JMS_MEDICAL_ASSESSMENT = 'JMS_MEDICAL_ASSESSMENT',
}

export interface IPersonFlag extends IAuditModel {
  _id: string;
  person: string;
  flag: IFlag;
  origin: FlagOrigin;
  systemType?: SystemFlagType;
  addedBy?: IUser;
  dateAssigned: Date;
  reason?: string;
  isDeleted: boolean;
  deleteReason?: string;
  deletedBy?: IUser;
  deletedAt?: Date;
}

export interface IFlagRequest {
  _id?: string;
  name: string;
  code: string;
  description?: string;
  isImportant?: boolean;
  isActive: boolean;
}

export interface IPersonFlagRequest {
  flagId: string;
  reason?: string;
}

export interface IPersonFlagUpdateRequest {
  reason?: string;
}

export interface IPersonFlagDeleteRequest {
  deleteReason: string;
}

export interface ISystemFlagRequest {
  systemType: SystemFlagType;
  reason?: string;
}

export interface IFlagOption {
  _id: string;
  name: string;
  code: string;
  description?: string;
  isImportant?: boolean;
}
